import React, { Fragment } from 'react'
import CTASectionResources from '../components/Resources/CTASection'
import HeroSection from '../components/common/HeroSection';
import data from '../resource.json';
import ResourceData from '../components/Resources/ResourceData';
import CTASection from '../components/common/CTASection';
import DigitalHealthFAB from '../components/Digitalhealth';
const {resource}=data;


const Resources = () => {
    const heroSlide=[resource.hero]
  return (
    <Fragment>
      <DigitalHealthFAB/>
        <HeroSection slides={heroSlide} />
        <ResourceData/>
        {/* <CTASectionResources/> */}
        <CTASection data={data.callToAction} />

    </Fragment>
  )
}

export default Resources